import { useQuery } from '@tanstack/react-query';
import { queryKeys } from '@sshop/api-client';

import { api } from '@/shared/lib/apiClient';
import { defineQuery } from '@/shared/lib/queryFactory';

export const categoryDetailQuery = (slug: string) =>
  defineQuery({
    queryKey: queryKeys.category.detail(slug),
    queryFn: ({ signal }) => api.categories.getDetail(slug, signal),
    staleTime: 5 * 60_000,
  });

export const useCategoryDetail = (slug: string | undefined) =>
  useQuery({ ...categoryDetailQuery(slug ?? ''), enabled: !!slug });
